"use strict";
/**
 * @module botframework-streaming
 */
/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var browserWebSocket_1 = require("./browserWebSocket");
exports.BrowserWebSocket = browserWebSocket_1.BrowserWebSocket;
var browserWebSocketClient_1 = require("./browserWebSocketClient");
exports.WebSocketClient = browserWebSocketClient_1.WebSocketClient;
/** @internal */
var webSocketTransport_1 = require("./webSocketTransport");
exports.WebSocketTransport = webSocketTransport_1.WebSocketTransport;
//# sourceMappingURL=index-browser.js.map